export const ApiUrl = 'https://api.hafsasoftware.eu/libraryuser/'
export const FileUrl = 'https://s3.eu-central-1.wasabisys.com/mylesson/1/'